export default "__VITE_ASSET__BYcGx$ra__"